import { jsx as _jsx } from "react/jsx-runtime";
/**
 * <Node3D>: an invisible transform container that applies the Godot Transform3D to a <group>, as
 * position, rotation and scale, or as the whole matrix for a sheared basis.
 */
import { useMemo } from 'react';
import { invisibleBase } from '../../../r3f/invisibleBase';
import { node3dGroupSpread, transformFromNode3DProperties } from '../../../r3f/nodeTransform';
export function Node3D({ node, children, ref }) {
    const props = node.properties;
    const transform = useMemo(() => transformFromNode3DProperties(props), [props]);
    // paint-order-safe: 3D content, which the canvas key never reaches. Only the
    // 2D canvas gives `groupOrder` a value.
    return (_jsx("group", { ref: ref, name: node.name, ...node3dGroupSpread(transform), children: children }));
}
invisibleBase(Node3D);
//# sourceMappingURL=Component.js.map